"use client";
import React from 'react';
import '../../src/styles/refundPolicy.css';
const RefundPolicy = () => {
    return (
        <div className='page-content'>
            <div className="about-area-three bg-image" style={{ background: '#CBBBDD', paddingTop: '220px', paddingBottom: '3%' }}>
                <div className="container">
                    <div className="row h-100 align-items-center refund-policy">
                        <div className="col-lg-12 refund-contact">
                            <div className="section-title refund-text refund-policy-contact-box">
                                <h2 className='refund-heading'>Cancellation and Refund Policy</h2>

                                <ol>
                                    <li>
                                        <strong>Booking Advance:</strong><br />
                                        A minimum advance of <strong>₹750</strong> is required to confirm your booking slot.
                                        If you choose to add a cake, an additional <strong>₹750 advance + the cost of the cake</strong> will be collected.
                                    </li>

                                    <li>
                                        <strong>Slot Cancellation:</strong>
                                        <ul>
                                            <li>
                                                If you cancel your booking <strong>3 days (72 hours) or more before</strong> the booking date,
                                                a cancellation charge of <strong>₹500</strong> will be deducted from the advance amount.
                                            </li>
                                            <li>
                                                If you cancel <strong>within 72 hours of the booking</strong>, a cancellation charge of <strong>₹750</strong> will apply.
                                            </li>
                                        </ul>
                                    </li>

                                    <li>
                                        <strong>Same-Day Cancellation:</strong><br />
                                        If you cancel your booking <strong>on the day of the occasion</strong>, there will be
                                        <strong> no refund for the booking slot or cake</strong>.
                                    </li>

                                    <li>
                                        <strong>Food Package Cancellation:</strong><br />
                                        For bookings that include a <strong>food package</strong>, an advance amount ranging from
                                        <strong> ₹7,500 up to ₹25,000 or more</strong> may be collected, depending on the selected
                                        package and number of guests.<br />
                                        <em>The advance paid towards the food package is strictly non-refundable under any circumstances.</em>
                                    </li>

                                    <li>
                                        <strong>Refund Method:</strong><br />
                                        Any eligible refund will be processed to the <strong>same payment method used by the customer</strong>.
                                    </li>

                                    <li>
                                        <strong>Cancellation Request:</strong><br />
                                        To cancel your booking, please contact the respective branch on WhatsApp as soon as possible:
                                        <ul>
                                            <li><strong>Kompally:</strong> +91 81216 97022</li>
                                            <li><strong>LB Nagar:</strong> +91 79955 72167</li>
                                            <li><strong>KPHB:</strong> +91 79955 72169</li>
                                        </ul>
                                    </li>

                                    <li>
                                        <strong>Refund Processing Time:</strong><br />
                                        Eligible refunds will be processed within <strong>7 business days</strong> from the date of
                                        receiving the cancellation request.
                                    </li>

                                    <li>
                                        <strong>For Any Queries:</strong><br />
                                        If you have any questions regarding our cancellation and refund policy, please contact the
                                        respective branch. Our team will be happy to assist you.
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RefundPolicy;